import React from 'react'
import { ContentWithBgProps } from './ContentWithBgTypes'

type MapStylingObjectType = {
  [index: string]: {
    [index: string]: string
  }
}

const mapStyles = (style: string, type: string): string => {
  const mappingStylesObj: MapStylingObjectType = {
    bg: {
      white: 'bg-white',
      light: 'bg-contentLightBg',
      dark: 'bg-contentDarkBg',
      black: 'bg-black'
    },
    font: {
      white: 'font-text-white',
      black: 'font-text-black'
    }
  }

  return mappingStylesObj[type][style] || ''
}

const MAX_HEIGHT = 1500

const ContentWithBg = ({
  bgStyle,
  bgImage,
  fontColor,
  showBackgroudOnText,
  offsetTop,
  offsetBottom,
  children
}: ContentWithBgProps) => {
  const bgImageUrl = bgImage ? bgImage.path : ''
  const bgColor = (!bgImage && mapStyles(bgStyle, 'bg')) || ''
  const textColor = mapStyles(fontColor, 'font')
  const imageHeight =
    (bgImage &&
      (bgImage.meta_data?.height > MAX_HEIGHT
        ? MAX_HEIGHT
        : bgImage.meta_data?.height)) ||
    null
  const mTop = (offsetTop && { marginTop: `${offsetTop}px` }) || {}
  const mBottom = (offsetBottom && { marginBottom: `${offsetBottom}px` }) || {}
  const margins = { ...mTop, ...mBottom }

  const extraStyles = {
    maxHeight: imageHeight || 'unset',
    height: imageHeight || 'auto',
    backgroundClassname: (showBackgroudOnText && ' text-overlay') || ''
  }

  return (
    <div
      className={`contentwithbg-wrapper min-h-[400px] ${bgColor}`}
      style={{ maxHeight: extraStyles.maxHeight }}
    >
      {bgImage && (
        <div
          className='contentwithbg-bgImage'
          style={{
            backgroundImage: `url('${bgImageUrl}')`
          }}
        ></div>
      )}
      <div
        className='scrolling-wrapper'
        style={{
          maxHeight:
            extraStyles.height !== 'auto'
              ? `calc(${extraStyles.height}px - 40px)`
              : extraStyles.height
        }}
      >
        <div
          className={`contentwithbg-content-wrapper ${textColor}${extraStyles.backgroundClassname}`}
          style={margins}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default ContentWithBg
